import React from 'react'
import { Dimensions, StyleSheet, Modal } from 'react-native'

import { View } from '../../../components/Themed'

const OrderConfirmedModalWrapper = ({ children, visible }) => {
	const window = Dimensions.get('window')
	const isSmallScreen = window.width < 768 || window.height < 600

	if (isSmallScreen) {
		return (
			<Modal
				visible={visible}
				animationType="slide"
				presentationStyle="fullScreen"
				statusBarTranslucent={true}
				transparent
			>
				{children}
			</Modal>
		)
	}
	return (
		<Modal visible={visible} animationType="fade" statusBarTranslucent={true} transparent>
			<View style={styles.desktopOverlay}>{children}</View>
		</Modal>
	)
}

const styles = StyleSheet.create({
	desktopOverlay: {
		flex: 1,
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		justifyContent: 'center',
		alignItems: 'center',
	},
})

export default OrderConfirmedModalWrapper
